import { DiscountState } from './state';

export const initialState: DiscountState = {
  discounts: [],
};
